import { SelectCompanyModalProps } from './SelectCompanyModal';
import { openModal } from '@core/components/ModalStack';

export async function openSelectCompanyModal(props: SelectCompanyModalProps) {
  const { SelectCompanyModal } = await import('./SelectCompanyModal');

  openModal(SelectCompanyModal, props);
}
